import { useMutation } from 'react-query';
import { useSnackbar } from '@goodfynd/context';
import type { PatchPutApiOptions } from 'types/api';

export function usePatchPutApi<TResult, TParams>({
  getSuccessMessage,
  request,
  ...options
}: PatchPutApiOptions<TResult, TParams>) {
  const { openSnackbarSuccess, openSnackbarWarning } = useSnackbar();

  const { data, isLoading, mutateAsync } = useMutation<TResult, Error, TParams>(
    request,
    {
      ...options,
      onError(error, ...args) {
        options?.onError?.(error, ...args);
        openSnackbarWarning({
          message: error?.message || 'An unknown error has occurred',
        });
      },
      onSuccess(data, ...args) {
        options?.onSuccess?.(data, ...args);
        openSnackbarSuccess({
          message: getSuccessMessage?.(data) ?? 'Updated successfully!',
        });
      },
    }
  );

  return {
    data,
    update: mutateAsync,
    isUpdating: isLoading,
  };
}
